import FileInput from '@gef-ui/components/atoms/FileInput/FileInput';
import FileInputV2 from '@gef-ui/components/atoms/FileInput/FileInputV2';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import compose from "ramda/es/compose";
import filter from "ramda/es/filter";
import map from "ramda/es/map";
import omit from "ramda/es/omit";
import propEq from "ramda/es/propEq";
import React from 'react';
import { validationColor } from '../../../../constants';
const omitFiles = map(omit([
    'file'
]));
export default (({ handleAsyncValidate, asyncValidationInProgress, handleChange, displayValue, viewParser, focus, errMeta, handleUpdate, handleValidate, disabled, onBlur, onChange, onFocus, handleFocusTrue, handleFocusFalse, fieldName, errMessage, valid, value, v2, formName, ...other })=>{
    const fieldId = `${formName}-${fieldName}`;
    if (v2) {
        const passFilesToState = (_e, files)=>{
            handleUpdate(fieldName, omitFiles(files));
        };
        return /*#__PURE__*/ React.createElement(FileInputV2, {
            id: fieldId,
            disabled: disabled,
            handleFileChange: chainHandlers([
                passFilesToState,
                handleValidate,
                onChange
            ]),
            onFocus: chainHandlers([
                handleFocusTrue,
                onFocus
            ]),
            onBlur: chainHandlers([
                handleFocusFalse,
                handleValidate,
                onBlur
            ]),
            validationText: errMessage,
            validationClassName: validationColor(valid),
            value: value || [],
            errMeta: errMeta,
            ...other
        });
    }
    const passFilesToState = (_e, files)=>{
        const filterValidFiles = filter(propEq(true, 'valid'));
        const toBlobFile = map(({ file })=>({
                name: file.name,
                size: file.size,
                blob: URL.createObjectURL(file)
            }));
        handleUpdate(fieldName, compose(toBlobFile, filterValidFiles)(files));
    };
    return /*#__PURE__*/ React.createElement(FileInput, {
        id: fieldId,
        disabled: disabled,
        handleFileChange: chainHandlers([
            passFilesToState,
            handleValidate,
            onChange
        ]),
        onFocus: chainHandlers([
            handleFocusTrue,
            onFocus
        ]),
        onBlur: chainHandlers([
            handleFocusFalse,
            handleValidate,
            onBlur
        ]),
        validationText: errMessage,
        validationClassName: validationColor(valid),
        ...other
    });
});
